<div class="bg_login d-flex">
  <div class="w-50 h-100 login_div">
    <div class="signup_form">
      <div class="text-center mb-4">
        <img src="assets/images/logo/resy_logo.png">
      </div>
      <h3 class="sign_up text-center">{{'SIGN_UP.SIGN_UP' | translate | uppercase}}
        <!-- <app-change-language [ShowFullName]="false"></app-change-language> -->
      </h3>
      <div class="signup_field row">
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.NAME' |translate}}
            <div *ngIf="errorModel!=null && errorModel['FirstName']!=null" class="invalid_signup_input">
              {{errorModel['FirstName'] | translate}}
            </div>
          </label>
          <input type="text" class="input_field w-100" [(ngModel)]="signupModel.firstName">
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.SURNAME' |translate}}
            <div *ngIf="errorModel!=null && errorModel['LastName']!=null" class="invalid_signup_input">
              {{errorModel['LastName'] | translate}}
            </div>
          </label>
          <input type="text" class="input_field w-100" [(ngModel)]="signupModel.lastName">
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.PASSWORD'|translate}}
            <div *ngIf="errorModel!=null && errorModel['Password']!=null" class="invalid_signup_input">
              {{errorModel['Password'] | translate}}
            </div>
          </label>
          <div *ngIf="(signupModel.password !== undefined && !isPasswordValid()) && (errorModel==null || errorModel['Password']==null)" class="invalid_signup_input">
            {{'INFO.INVALID_PASSWORD' | translate}}
          </div>
          <p-password [(ngModel)]="signupModel.password" [toggleMask]="true" [feedback]="false"
            [styleClass]="'p-password p-component p-inputwrapper p-input-icon-right col-12'"
            [id]="'sign_up_password_filed'" (click)="openTooltip(t1)" (mouseleave)="closeTooltip(t1)"
            (mouseenter)="openTooltip(t1)" [inputStyleClass]="'input_field password-input-field'"
            [ngbTooltip]="passwordInfoTooltipContent" [animation]="false" [placement]="['right', 'left']" triggers="manual"
            tooltipClass="signup-password-tooltip" #t1="ngbTooltip" [autoClose]="false"></p-password>
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.CONFIRM_PASSWORD'|translate}}
            <div *ngIf="errorModel!=null && errorModel['ConfirmPassword']!=null" class="invalid_signup_input">
              {{errorModel['ConfirmPassword'] | translate}}
            </div>
          </label>
          <p-password [(ngModel)]="signupModel.confirmPassword" [feedback]="false" [toggleMask]="true"
            [styleClass]="'p-password p-component p-inputwrapper p-input-icon-right'" [id]="'sign_up_password_filed'"
            [inputStyleClass]="'input_field password-input-field'">
          </p-password>
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.EMAIL'|translate}}
            <div *ngIf="errorModel!=null && errorModel['Email']!=null" class="invalid_signup_input">
              {{errorModel['Email'] | translate}}
            </div>
            <div *ngIf="email.touched && email.errors?.pattern && (errorModel==null || errorModel['Email']==null)" class="invalid_signup_input">
              {{'INFO.INVALID_EMAIL' | translate}}
            </div>
          </label>
          <input type="email" class="input_field col-12" [(ngModel)]="signupModel.email"
                 #email=ngModel required pattern="^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$">
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.PHONE'|translate}}
            <div *ngIf="errorModel!=null && errorModel['Phone']!=null" class="invalid_signup_input">
              {{errorModel['Phone'] | translate}}
            </div>
          </label>
          <input type="number" class="input_field w-100 custom_number_input" [(ngModel)]="signupModel.phone">
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.COUNTRY'|translate}}
            <div *ngIf="errorModel!=null && errorModel['Country']!=null" class="invalid_signup_input">
              {{errorModel['Country'] | translate}}
            </div>
          </label>
          <p-dropdown class="src_dropdown country_dropdown" [autoDisplayFirst]=false [options]="counries"
                      [(ngModel)]="signupModel.countryId" (onChange)="changeCountry($event)" optionLabel="countryName" optionValue="id"></p-dropdown>
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.ADDRESS'|translate}}
            <div *ngIf="errorModel!=null && errorModel['Address']!=null" class="invalid_signup_input">
              {{errorModel['Address'] | translate}}
            </div>
          </label>
          <input #search type="text" class="input_field w-100" autocapitalize="off" [(ngModel)]="signupModel.address"
                 placeholder="" spellcheck="false" (input)="onAddressManualChange()">
        </div>
        <div class="col-6 ">
          <label class="lbl_resy_field col-12">{{'SIGN_UP.COMPANY_NAME'|translate}}
            <div *ngIf="errorModel!=null && errorModel['CompanyName']!=null" class="invalid_signup_input">
              {{errorModel['CompanyName'] | translate}}
            </div>
          </label>
          <input type="text" class="input_field w-100" [(ngModel)]="signupModel.companyName">
        </div>
        <div class="col-6 "></div>
        <div class="col-6 ">
          <button class="btn_login w-100" (click)="signup(signupModel)"
                  [disabled]="spinner || !isPasswordValid() || email.errors?.pattern">{{'INFO.SIGN_UP' | translate}}</button>
          <div class="small_spinner_wrapper_no_auth mb-3 mt-2" *ngIf="spinner">
            <p-progressSpinner class="w-100 text-center pos_spinner_small"></p-progressSpinner>
          </div>
        </div>
        <div class="col-6 ">
          <button class="btn_without_color w-100" (click)="cancel()" [disabled]="spinner">{{'CANCEL' | translate}}</button>
        </div>
        <div class="col-6 ">
          <p class="p_sign_up">{{'INFO.ALREADY_REGISTERED' | translate}} <a type="button" routerLink="/login"
              class="signup_link text-center">{{'INFO.SIGN_IN' | translate }}</a></p>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #passwordInfoTooltipContent>
  <div class="password-tooltip-content">
    <span>{{'INFO.PASSWORD_PATTERN_MESSAGE_1' | translate}} </span>
    <span [class.password-rule-checked]="has8Characters()">{{'INFO.PASSWORD_PATTERN_MESSAGE_2' | translate}} </span>
    <span>{{'INFO.PASSWORD_PATTERN_MESSAGE_3' | translate}}</span>
    <ul>
      <li [class.password-rule-checked]="hasUppercaseLetter()">{{'INFO.PASSWORD_1_UPPERCASE' | translate}}</li>
      <li [class.password-rule-checked]="hasLowercaseLetter()">{{'INFO.PASSWORD_1_LOWERCASE' | translate}}</li>
      <li [class.password-rule-checked]="hasSpecialCharacter()">{{'INFO.PASSWORD_SPECIAL_CHAR' | translate}} (:, ?, @..)
      </li>
    </ul>
  </div>
</ng-template>
